import { useRef, useState } from 'react'
import { Modal, Button, Box, Stack, Flex, useDisclosure } from 'summon-ui/mantine'
import { SharingItem } from './types'
import useShare from './useShare'

interface Props {
  variant: SharingItem
  isOpened?: boolean
  asButton?: boolean
  buttonText?: string
}

const SocialSharingModal = ({ variant, isOpened = false, asButton = true, buttonText = 'Open modal' }: Props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const [opened, { open, close }] = useDisclosure(isOpened)
  const [isReadyToShare, setIsReadyToShare] = useState(false)
  const { getSharingInfo, renderSharingButton } = useShare(variant)
  const { Component, downloadSharingImg } = getSharingInfo(canvasRef)

  const handleDownloadSharingImg = () => {
    downloadSharingImg()
    setIsReadyToShare(true)
  }

  const handleClose = () => {
    setIsReadyToShare(false)
    close()
  }

  return (
    <>
      <Modal withOverlay opened={opened} onClose={close} withCloseButton={false}>
        <Box className='p-2'>
          <Stack gap='lg'>
            {Component}
            <Stack gap='md'>
              <Flex gap='md'>
                <Button onClick={handleClose} fullWidth variant='outline' color='gray'>
                  Close
                </Button>
                {isReadyToShare ? (
                  renderSharingButton('X')
                ) : (
                  <Button onClick={handleDownloadSharingImg} fullWidth>
                    Download
                  </Button>
                )}
              </Flex>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      {asButton && <Button onClick={open}>{buttonText}</Button>}
    </>
  )
}

export default SocialSharingModal
